'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(o, e) {
    if (null == o) return {};
    var r, t, n = _object_without_properties_loose(o, e);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(o);
        for(t = 0; t < i.length; t++)r = i[t], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(o, r) && (n[r] = o[r]);
    }
    return n;
}
function _object_without_properties_loose(o, e) {
    if (null == o) return {};
    var r, t, n = {}, i = Object.keys(o);
    for(t = 0; t < i.length; t++)r = i[t], e.indexOf(r) >= 0 || (n[r] = o[r]);
    return n;
}
const ModalDialogBody = renderWithRef('ModalDialogBody', null, (r, t)=>{
    var { children: n } = r;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: t,
        props: _object_without_properties(r, [
            "children"
        ]),
        classNames: [
            'swan-modal-dialog-body'
        ],
        children: n
    });
});

export { ModalDialogBody };
